import Button from '../../../components/Button';
import Rollback from '../../../components/Rollback';
import noProjectsImage from '../../../assets/icons/no-projects.png';

import { useMemo } from 'react';
import { Wrapper } from '../../Dashboard/style';
import { ProjectContainer } from '../style';
import { useGetTemplatesList } from '../../../services/workflow.services';
import EditIcon from '../../../assets/icons/pencil-line.svg?react';
import DeleteIcon from '../../../assets/icons/delete-bin.svg?react';
import NavigateIcon from '../../../assets/icons/navigate.svg?react';
import Table from '../../../components/Table';
import moment from 'moment';
import IconButton from '../../../components/IconButton';
import { useNavigate, useParams } from 'react-router-dom';

const NoTemplates = ({ onClick }) => (
  <div className="empty">
    <img src={noProjectsImage} width={120} />
    <h2>Create a new template</h2>

    <Button onClick={onClick}>Create New</Button>
  </div>
);

export default function Template() {
  const navigate = useNavigate();

  const { workflowId } = useParams();

  const {
    data: templates,
    isLoading,
    refetch
  } = useGetTemplatesList({
    workflowId,
    queryParams: {
      enabled: !!workflowId
    }
  });

  const _columns = useMemo(
    () => [
      { title: 'Name', key: 'name' },
      {
        title: 'Created date',
        key: 'created_at',
        render: data => {
          return moment(data.created_at).format('DD-MM-YYYY HH:mm');
        }
      },
      {
        title: '',
        key: 'actions',
        render: data => {
          return (
            <div className="table_actions">
              <IconButton icon={<NavigateIcon />} onClick={() => navigate(`${data.id}`)} />
              <IconButton icon={<EditIcon />} onClick={() => {}} />
              <IconButton icon={<DeleteIcon />} />
            </div>
          );
        }
      }
    ],
    []
  );

  return (
    <>
      <Wrapper>
        <ProjectContainer>
          <div className="header">
            <Rollback title="Back" onClick={() => navigate(-1)} />
            <Button onClick={() => navigate('create')}>Create New</Button>
          </div>
          <div className="box">
            {!isLoading && (!templates || templates?.length === 0) && (
              <NoTemplates onClick={() => navigate('create')} />
            )}

            {isLoading ? (
              <h2></h2>
            ) : (
              templates?.length > 0 && <Table columns={_columns} data={templates} />
            )}
          </div>
        </ProjectContainer>
      </Wrapper>
    </>
  );
}
